export default __webpack_public_path__ + "static/media/ri_arrow-top-s-line-blue.a3048f1a.svg";